module.exports = "/static/assets/5804a535f24c1b832b4a0602eeded176.png";